<div
  id="user-badge"
  class="badge-overlay"
  [ngClass]="{
    'preview-badge': isPreviewCard && !customStyle,
    'custom-style': !isPreviewCard || customStyle || isOnboardingExperience(),
    'summary-badge': isSummaryView,
    'timeline-menu': summaryTimeline,
  }"
  cdkDragBoundary=".boundary"
  cdkDrag
  [cdkDragDisabled]="disableDrag"
  [matTooltip]="
    isPreviewCard ? 'This is a preview of what your Smart Badge will look like in the Scootaverse.' : undefined
  "
  [matTooltipShowDelay]="1000"
  [matTooltipPositionAtOrigin]="true"
  [matTooltipDisabled]="hoveringChild"
  [cdkDragFreeDragPosition]="dragPosition"
>
  <div class="badge">
    <!-- Header content -->

    @if (isPreviewCard && !customStyle) {
      <div class="badge-preview-title">
        <div>
          <h1 class="name-wrapper">{{ userName }}</h1>
          's Badge Preview
        </div>
        <div><img alt="Information Icon" src="assets/icons/info.svg" class="badge-icon" /></div>
      </div>
    }
    <div class="badge-main-session">
      <div class="user-profile-flex">
        @if (!userOpenOwnBadge && !isSummaryView && !summaryTimeline) {
          <span id="btnBadgeFavorite" class="favorite-container" (click)="clickedFavoriteIcon()">
            <mat-icon
              class="favorite-icon"
              aria-hidden="false"
              aria-label="Favorite button"
              svgIcon="{{ isFavorite ? 'FAVORITE_STAR_FILL' : 'FAVORITE_STAR' }}"
            ></mat-icon>
          </span>
        }
        <profile-picture [user]="user" [size]="65" [borderWidth]="'3'" [borderColor]="ringColor"></profile-picture>
      </div>

      <div class="badge-main-content">
        <div class="title-row">
          <div class="badge-title" [title]="userName" [ngStyle]="{ maxWidth: '170px' }">
            {{ userName | truncate: 35 }}
          </div>
          @if (showEditIcon) {
            <div class="badge-edit-container">
              <button class="badge-edit-button" (click)="openEditBadge()"><mat-icon>edit</mat-icon></button>
            </div>
          }
          @if (!isPreviewCard && !customStyle && !summaryTimeline) {
            <div class="badge-close-container">
              <button class="badge-close-button" (click)="closeBadge()"><mat-icon>close</mat-icon></button>
            </div>
          }
        </div>

        <div class="badge-subtitle-row">
          <span class="badge-subtitle">{{ badgeSubtitle }}</span>
          <div class="social-icons">
            @if (badgeLinkedIn) {
              <a (click)="onClickSocial('LinkedIn', badgeLinkedIn)">
                <img alt="LinkedIn Icon" src="assets/images/social-media-icons/linkedin-square.svg" />
              </a>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Main content with tabs -->

    <div class="badge-complementary-session badge-tab">
      <mat-tab-group mat-align-tabs="start" disablePagination="true" mat-stretch-tabs="false">
        <mat-tab label="About">
          <div class="about-div">
            @if (badgeAboutMe) {
              <div class="badge-about-me" [class.show]="showBtn">
                <div #aboutMeSection>
                  {{ badgeAboutMe }}
                </div>
              </div>
            } @else {
              <div class="default-message">
                <div class="message">{{ defaultAboutMeMessage }}</div>
              </div>
            }
            @if (aboutMeShowButton) {
              <button class="show-btn" (click)="handleShowMoreLessBtn()">
                {{ showBtn ? '...see less' : '...see more' }}
              </button>
            }
            @if (shouldShowFeaturedRow) {
              <div class="featured-questions">
                @for (question of featuredQuestions; track question) {
                  @if (shouldShowQuestion(question)) {
                    <div
                      class="feature-badge"
                      [matTooltip]="featureChipMaxWidth(question.value ?? '') ? question.value : ''"
                    >
                      <div>
                        {{ question.value }}
                      </div>
                      @if (
                        newVisualIndicators && !isPreviewCard && shouldShowIndicator(question.propertyName) && ringColor
                      ) {
                        <app-ring-colors-legend
                          [ringContainerPosition]="{ position: 'fixed' }"
                          [dynamicallyPosition]="{ right: '30px', bottom: '130px' }"
                        >
                          <div class="legend-dot" style="--color: {{ ringColor }}"></div>
                        </app-ring-colors-legend>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        </mat-tab>
        @if (shouldShowDetailsSection) {
          <mat-tab label="Details">
            <div class="details-tab">
              <div class="details-div">
                @if (shouldShowTableRow) {
                  <table class="table-questions">
                    @for (question of tableQuestions; track question) {
                      @if (shouldShowQuestion(question)) {
                        <tr>
                          <td class="column-title">{{ question.propertyName }}</td>
                          <td class="column-response">
                            {{ question.value }}
                            @if (
                              newVisualIndicators &&
                              !isPreviewCard &&
                              shouldShowIndicator(question.propertyName) &&
                              ringColor
                            ) {
                              <app-ring-colors-legend
                                [ringContainerPosition]="{ position: 'fixed' }"
                                [dynamicallyPosition]="{ right: '30px', bottom: '130px' }"
                              >
                                <div class="legend-dot" style="--color: {{ ringColor }}"></div>
                              </app-ring-colors-legend>
                            }
                          </td>
                        </tr>
                      }
                    }
                  </table>
                } @else {
                  <div>
                    <div class="default-message">
                      <div class="details-message">
                        Gather and display information about your participants during your event with
                        <a (click)="openSmartBadgingArticle()">Smart Badging</a>. Ask your Customer Success Manager
                        about Smart Badging to learn more.
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>

    <!-- Footer with action buttons -->

    @if (!isSummaryView && !summaryTimeline) {
      <div
        class="utils-row"
        [matTooltip]="blockActionButtons ? blockActionMessage : ''"
        matTooltipPosition="above"
        matTooltipClass="badge-action-tooltip"
        [ngClass]="{ 'block-action-icons': blockActionButtons }"
      >
        <div
          class="utils-icons"
          [ngClass]="{ 'engaged-button': findEngaged }"
          [matTooltip]="!blockActionButtons ? (isOnPresentation ? blockActionMessage : 'Find') : ''"
          (mouseenter)="hoveringChild = true"
          (mouseleave)="hoveringChild = false"
        >
          @if (userOpenOwnBadge || isOnPresentation || blockActionButtons) {
            <button id="disabled_find" data-testid="btn-disabled-find" aria-label="Disabled Find" [disabled]="true">
              <mat-icon class="util-icon-button" svgIcon="FIND_DISABLED"></mat-icon>
            </button>
          }
          @if (!userOpenOwnBadge && !isOnPresentation && !blockActionButtons) {
            <button
              id="btn_find"
              data-testid="btn-find"
              aria-label="Find Button"
              (click)="findUserOnMap()"
              [disabled]="isPreviewCard"
            >
              <mat-icon class="util-icon-button">map</mat-icon>
            </button>
          }
        </div>
        <div
          class="utils-icons"
          [ngClass]="{ 'engaged-button': teleportEngaged }"
          [matTooltip]="!blockActionButtons ? (isOnViewport || isOnPresentation ? blockActionMessage : 'Teleport') : ''"
          (mouseenter)="hoveringChild = true"
          (mouseleave)="hoveringChild = false"
        >
          @if (userOpenOwnBadge || isOnViewport || isOnPresentation || blockActionButtons) {
            <button
              id="disabled_teleport"
              data-testid="btn-disabled-teleport"
              aria-label="Disabled Teleport"
              [disabled]="true"
            >
              <mat-icon class="util-icon-button" svgIcon="TELEPORT_DISABLED"></mat-icon>
            </button>
          }
          @if (!userOpenOwnBadge && !isOnViewport && !isOnPresentation && !blockActionButtons) {
            <button
              id="btn_teleport"
              data-testid="btn-teleport"
              aria-label="Teleport Button"
              (click)="teleportToUser()"
              [disabled]="isPreviewCard"
            >
              @if (teleportEngaged) {
                <mat-icon class="util-icon-button" svgIcon="TELEPORT"></mat-icon>
              } @else {
                <mat-icon class="util-icon-button" svgIcon="TELEPORT_OCEAN"></mat-icon>
              }
            </button>
          }
        </div>
        <div
          class="utils-icons"
          [matTooltip]="!blockActionButtons ? 'Chat' : ''"
          [ngClass]="{ 'engaged-button': chatEngaged }"
          (mouseenter)="hoveringChild = true"
          (mouseleave)="hoveringChild = false"
        >
          @if (userOpenOwnBadge || blockActionButtons) {
            <button id="disabled_chat" data-testid="btn-disabled-chat" aria-label="Disabled Chat" [disabled]="true">
              <mat-icon class="util-icon-button" svgIcon="CHAT_DISABLED"></mat-icon>
            </button>
          }
          @if (!userOpenOwnBadge && !blockActionButtons) {
            <button
              id="btn_chat"
              data-testid="btn-chat"
              aria-label="Chat Button"
              (click)="toggleChat()"
              [disabled]="isPreviewCard"
            >
              <mat-icon class="util-icon-button">chat_bubble</mat-icon>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
